var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-pagination"},[_c('button',{class:[
      'invoice-pagination__page-nav-btn',
      _vm.currentPage === 1 && 'invoice-pagination__page-nav-btn--disabled' ],domProps:{"innerHTML":_vm._s('<')},on:{"click":function($event){return _vm.setCurrentPage(_vm.currentPage - 1)}}}),_vm._l((Object.keys(_vm.pages)),function(page){return _c('button',{key:page,class:[
      'invoice-pagination__page-no-btn',
      parseInt(page) === _vm.currentPage &&
        'invoice-pagination__page-no-btn--selected' ],on:{"click":function($event){_vm.setCurrentPage(parseInt(page))}}},[_vm._v("\n    "+_vm._s(page)+"\n  ")])}),_c('button',{class:[
      'invoice-pagination__page-nav-btn',

      _vm.currentPage === _vm.totalPages &&
        'invoice-pagination__page-nav-btn--disabled' ],domProps:{"innerHTML":_vm._s('>')},on:{"click":function($event){return _vm.setCurrentPage(_vm.currentPage + 1)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }